/* eslint-disable */
import React, { createContext, useReducer } from 'react';
const userRight = createContext([]);
export const MenuContext = createContext();
export const UploadFileContext = createContext({ value: null, setValue: () => {} });
export const FileReaderContext = createContext({ value: null, setValue: () => {} });
export default {
  userRight,
};
